var map = {
	"./accordion_arrow.svg": 2408,
	"./arrow_left.svg": 1219,
	"./arrow_right.svg": 8137,
	"./close-dialog-icon.svg": 1071,
	"./copy_icon.svg": 2796,
	"./expert_avatar_1.jpg": 8689,
	"./expert_avatar_2.jpg": 1759,
	"./expert_avatar_3.jpg": 9,
	"./facebook_icon.svg": 1095,
	"./frater_main_logo.svg": 3502,
	"./frater_main_logo_gold.svg": 9026,
	"./header_logo.svg": 1395,
	"./help_step_bg_1.jpg": 2210,
	"./help_step_bg_2.jpg": 7697,
	"./help_step_bg_3.jpg": 4337,
	"./info_icon.svg": 1387,
	"./instagram_icon.svg": 1290,
	"./linked_in_icon.svg": 6275,
	"./monobank_logo.png": 8593,
	"./partner_1.jpg": 195,
	"./partner_2.png": 131,
	"./partner_3.jpg": 9059,
	"./play.svg": 8215,
	"./poster_preview_1.jpg": 5203,
	"./poster_preview_2.jpg": 3778,
	"./poster_preview_3.jpg": 4977,
	"./poster_preview_4.jpg": 4860,
	"./poster_preview_5.jpg": 5939,
	"./poster_preview_6.jpg": 3407,
	"./poster_preview_7.jpg": 327,
	"./poster_preview_8.jpg": 9395,
	"./poster_preview_9.jpg": 6630,
	"./poster_section_pixel.png": 3525,
	"./preview_image_1.jpg": 1327,
	"./preview_image_2.jpg": 1715,
	"./preview_image_3.jpg": 7830,
	"./preview_image_4.jpg": 8298,
	"./primecore_logo.png": 8100,
	"./primecore_logo.svg": 3697,
	"./project_section_mobile_pixel.png": 1721,
	"./project_section_pixel.png": 1904,
	"./project_worker_1.jpg": 95,
	"./project_worker_2.jpg": 3544,
	"./project_worker_3.jpg": 2589,
	"./scroll_left_icon.svg": 4867,
	"./scroll_right_icon.svg": 8816,
	"./share_icon.svg": 4040,
	"./success_icon.png": 1435,
	"./telegram_icon.svg": 2159,
	"./top_footer_pixel.png": 5485,
	"./twitter_icon.svg": 7108,
	"./ukraine_flag_icon.svg": 4425,
	"./video_preview.png": 4582,
	"./whats_app_icon.svg": 1089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;